import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {provideTransloco, TranslocoModule} from '@jsverse/transloco';
import {TranslocoHttpLoaderService} from './transloco-http-loader.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: [
    TranslocoModule,
  ],
  providers: [
    TranslocoHttpLoaderService,
    provideTransloco({
      config: {
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoaderService,
    }),
  ],
})
export class TranslocoRootModule {
}
